import { render, staticRenderFns } from "./InsurerSpecialRates.vue?vue&type=template&id=213281a6"
import script from "./InsurerSpecialRates.vue?vue&type=script&lang=js"
export * from "./InsurerSpecialRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports